<template>
  <TenderPlug
    :title="$t('No offers yet')"
    :description="$t('A comparison table will be available as soon as the first bid is submitted')"
    icon="bell"
    large
  >
    <template #action>
      <Button icon="plus" @click="$emit('action')">
        {{ $t('Invite contractors') }}
      </Button>
    </template>
  </TenderPlug>
</template>

<script>
  import TenderPlug from '@/components/tender/TenderPlug';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'NoOffersPlug',
    components: {
      TenderPlug,
      Button,
    },
  };
</script>

<style scoped></style>
